customElements.define('component-cart-loyalty-banner', class CartLoyaltyBanner extends HTMLElement {
  constructor() {
    super();

    this.dom = {
      logo: this.querySelector('.js-cart-loyalty-banner-logo'),
      title: this.querySelector('.js-cart-loyalty-banner-title'),
      firstText: this.querySelector('.js-cart-loyalty-banner-text-1'),
      secondText: this.querySelector('.js-cart-loyalty-banner-text-2')
    };

    this.settings = {
      loyaltyCustomerTags: window.theme?.loyalty?.loyalty_customer_tags || [],
      customerEmail: window.theme?.customer?.email,
      customerTags: window.theme?.customer?.tags || [],
      enabled: this.dataset.enabled === 'true',
      emptyCartEnabled: this.dataset.emptyCartEnabled === 'true',
      visitorTitle: this.dataset.visitorTitle,
      customerTitle: this.dataset.customerTitle,
      subscribedCustomerFirstTierTitle: this.dataset.subscribedCustomerFirstTierTitle,
      subscribedCustomerSecondTierTitle: this.dataset.subscribedCustomerSecondTierTitle,
      emptyCartVisitorTitle: this.dataset.emptyCartVisitorTitle,
      emptyCartCustomerTitle: this.dataset.emptyCartCustomerTitle,
      emptyCartSubscribedCustomerFirstTierTitle: this.dataset.emptyCartSubscribedCustomerFirstTierTitle,
      emptyCartSubscribedCustomerSecondTierTitle: this.dataset.emptyCartSubscribedCustomerSecondTierTitle,
      visitorFirstText: this.dataset.visitorFirstText,
      visitorSecondText: this.dataset.visitorSecondText,
      customerFirstTextTemplate: this.dataset.customerFirstTextTemplate,
      customerSecondTextTemplate: this.dataset.customerSecondTextTemplate,
      subscribedCustomerFirstTierFirstTextTemplate: this.dataset.subscribedCustomerFirstTierFirstTextTemplate,
      subscribedCustomerSecondTierFirstTextTemplate: this.dataset.subscribedCustomerSecondTierFirstTextTemplate,
      subscribedCustomerFirstTierSecondTextTemplate: this.dataset.subscribedCustomerFirstTierSecondTextTemplate,
      subscribedCustomerSecondTierSecondTextTemplate: this.dataset.subscribedCustomerSecondTierSecondTextTemplate,
      emptyCartVisitorFirstText: this.dataset.emptyCartVisitorFirstText,
      emptyCartVisitorSecondText: this.dataset.emptyCartVisitorSecondText,
      emptyCartCustomerFirstTextTemplate: this.dataset.emptyCartCustomerFirstTextTemplate,
      emptyCartCustomerSecondTextTemplate: this.dataset.emptyCartCustomerSecondTextTemplate,
      emptyCartSubscribedCustomerFirstTierFirstTextTemplate: this.dataset.emptyCartSubscribedCustomerFirstTierFirstTextTemplate,
      emptyCartSubscribedCustomerSecondTierFirstTextTemplate: this.dataset.emptyCartSubscribedCustomerSecondTierFirstTextTemplate,
      emptyCartSubscribedCustomerFirstTierSecondTextTemplate: this.dataset.emptyCartSubscribedCustomerFirstTierSecondTextTemplate,
      emptyCartSubscribedCustomerSecondTierSecondTextTemplate: this.dataset.emptyCartSubscribedCustomerSecondTierSecondTextTemplate,
      logoSrc: this.dataset.logoSrc,
      logoAlt: this.dataset.logoAlt,
      emptyCartLogoSrc: this.dataset.emptyCartLogoSrc,
      emptyCartLogoAlt: this.dataset.emptyCartLogoAlt
    };

    this.settings.customerSubscribed = this.settings.customerTags?.some(customerTag => this.settings.loyaltyCustomerTags?.includes(customerTag));

    if (!this.dom.firstText || !this.dom.secondText) {
      this.remove();
      if (window.theme?.loyalty) window.theme.loyalty.is_cart_loyalty_banner_displayed = false;
      console.error('Error rendering Cart Loyalty Banner.');
      return;
    }

    if (window.theme?.loyalty) window.theme.loyalty.is_cart_loyalty_banner_displayed = true;

    this.setEventListeners();
  }

  async renderTexts(dom, settings) {
    const cart = await window.cartManager?.getLocalCartAsync();

    const totalBalance = window.theme.loyalty?.customer?.points || 0;

    if (cart) {
      const loyaltyOrdinalTier = window.theme.loyalty?.customer?.tier_ordinal;
      if (!settings.enabled && cart.items.length) {
        this.classList.add('hidden');
        return;
      } else if (!settings.emptyCartEnabled && !cart.items.length) {
        this.classList.add('hidden');
        return;
      } else if (settings.customerEmail &&
        settings.customerSubscribed &&
        cart.items.length &&
        window.theme?.loyalty &&
        loyaltyOrdinalTier &&
        window.theme.loyalty[`loyalty_${loyaltyOrdinalTier}_tier_points_earned_per_each_dollar_spent`] &&
        window.theme.loyalty[`loyalty_${loyaltyOrdinalTier}_tier_points_to_earn_one_dollar`]
      ) {
        const points = Math.floor(cart.total_with_discount_codes / 100) * window.theme.loyalty[`loyalty_${loyaltyOrdinalTier}_tier_points_earned_per_each_dollar_spent`];
        const money = (points / window.theme.loyalty[`loyalty_${loyaltyOrdinalTier}_tier_points_to_earn_one_dollar`]).toFixed(2);
        if (dom.logo && settings.logoSrc && settings.logoAlt) {
          dom.logo.src = settings.logoSrc;
          dom.logo.alt = settings.logoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        const loyaltyOrdinalTierCapitalize = loyaltyOrdinalTier.charAt(0).toUpperCase() + loyaltyOrdinalTier.slice(1);
        if (loyaltyOrdinalTierCapitalize && settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierTitle`]) {
          dom.title.innerHTML = settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierTitle`];
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (loyaltyOrdinalTierCapitalize && settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierFirstTextTemplate`]) {
          dom.firstText.innerHTML = settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierFirstTextTemplate`].replace('#name', window.theme.loyalty.customer.first_name).replace('#points', points).replace('#money', money).replace('#tier', window.theme.loyalty.customer.tier_name).replace('#balance', totalBalance);
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (loyaltyOrdinalTierCapitalize && settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierSecondTextTemplate`]) {
          dom.secondText.innerHTML = settings[`subscribedCustomer${loyaltyOrdinalTierCapitalize}TierSecondTextTemplate`].replace('#points', window.theme.loyalty.customer.points).replace('#points', points).replace('#money', money).replace('#tier', window.theme.loyalty.customer.tier_name).replace('#balance', totalBalance);
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      } else if (settings.customerEmail && settings.customerSubscribed && !cart.items.length) {
        const loyaltyOrdinalTierCapitalize = loyaltyOrdinalTier.charAt(0).toUpperCase() + loyaltyOrdinalTier.slice(1);
        if (dom.logo && settings.emptyCartLogoSrc && settings.emptyCartLogoAlt) {
          dom.logo.src = settings.emptyCartLogoSrc;
          dom.logo.alt = settings.emptyCartLogoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        if (loyaltyOrdinalTierCapitalize && settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierTitle`]) {
          dom.title.innerHTML = settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierTitle`];
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (loyaltyOrdinalTierCapitalize && settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierFirstTextTemplate`]) {
          dom.firstText.innerHTML = settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierFirstTextTemplate`].replace('#name', window.theme.loyalty.customer.first_name).replace('#tier', window.theme.loyalty.customer.tier_name).replace('#balance', totalBalance);
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (loyaltyOrdinalTierCapitalize && settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierSecondTextTemplate`]) {
          dom.secondText.innerHTML = settings[`emptyCartSubscribedCustomer${loyaltyOrdinalTierCapitalize}TierSecondTextTemplate`].replace('#name', window.theme.loyalty.customer.first_name).replace('#tier', window.theme.loyalty.customer.tier_name).replace('#balance', totalBalance);
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      } else if (settings.customerEmail && !settings.customerSubscribed && cart.items.length) {
        if (dom.logo && settings.logoSrc && settings.logoAlt) {
          dom.logo.src = settings.logoSrc;
          dom.logo.alt = settings.logoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        if (settings.customerTitle) {
          dom.title.innerHTML = settings.customerTitle;
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (settings.customerFirstTextTemplate) {
          dom.firstText.innerHTML = settings.customerFirstTextTemplate.replace('#name', window.theme.loyalty.customer.first_name).replace('#balance', totalBalance);
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (settings.customerSecondTextTemplate) {
          dom.secondText.innerHTML = settings.customerSecondTextTemplate.replace('#name', window.theme.loyalty.customer.first_name).replace('#balance', totalBalance);
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      } else if (settings.customerEmail && !settings.customerSubscribed && !cart.items.length) {
        if (dom.logo && settings.emptyCartLogoSrc && settings.emptyCartLogoAlt) {
          dom.logo.src = settings.emptyCartLogoSrc;
          dom.logo.alt = settings.emptyCartLogoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        if (settings.emptyCartCustomerTitle) {
          dom.title.innerHTML = settings.emptyCartCustomerTitle;
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (settings.emptyCartCustomerFirstTextTemplate) {
          dom.firstText.innerHTML = settings.emptyCartCustomerFirstTextTemplate.replace('#name', window.theme.loyalty.customer.first_name).replace('#balance', totalBalance);
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (settings.emptyCartCustomerSecondTextTemplate) {
          dom.secondText.innerHTML = settings.emptyCartCustomerSecondTextTemplate.replace('#name', window.theme.loyalty.customer.first_name).replace('#balance', totalBalance);
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      } else if (cart.items.length) {
        if (dom.logo && settings.logoSrc && settings.logoAlt) {
          dom.logo.src = settings.logoSrc;
          dom.logo.alt = settings.logoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        if (settings.visitorTitle) {
          dom.title.innerHTML = settings.visitorTitle;
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (settings.visitorFirstText) {
          dom.firstText.innerHTML = settings.visitorFirstText;
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (settings.visitorSecondText) {
          dom.secondText.innerHTML = settings.visitorSecondText;
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      } else {
        if (dom.logo && settings.emptyCartLogoSrc && settings.emptyCartLogoAlt) {
          dom.logo.src = settings.emptyCartLogoSrc;
          dom.logo.alt = settings.emptyCartLogoAlt;
          dom.logo.classList.remove('hidden');
        } else {
          dom.logo.classList.add('hidden');
        }
        if (settings.emptyCartVisitorTitle) {
          dom.title.innerHTML = settings.emptyCartVisitorTitle;
          dom.title.classList.remove('hidden');
        } else {
          dom.title.classList.add('hidden');
        }
        if (settings.emptyCartVisitorFirstText) {
          dom.firstText.innerHTML = settings.emptyCartVisitorFirstText;
          dom.firstText.classList.remove('hidden');
        } else {
          dom.firstText.classList.add('hidden');
        }
        if (settings.emptyCartVisitorSecondText) {
          dom.secondText.innerHTML = settings.emptyCartVisitorSecondText;
          dom.secondText.classList.remove('hidden');
        } else {
          dom.secondText.classList.add('hidden');
        }
        this.classList.remove('hidden');
      }
    } else {
      console.error('Error rendering Cart Loyalty Banner.');
    }
  }

  setEventListeners() {
    window.addEventListener('update-cart-loyalty-banner', () => {
      if (this.dom.firstText && this.dom.secondText) {
        this.renderTexts(this.dom, this.settings);
      }
    });
  }
});
